























import {Component, Vue} from 'vue-property-decorator';
import MyToolbar from '@/components/ui/MyToolbar.vue';

@Component({components: {MyToolbar}})
export default class App extends Vue {

  get isLoading(): boolean {
    return this.$store.state.loading;
  }

}
